module.exports = __webpack_public_path__ + "static/media/icon_syrup.100247ae.svg";